import React, {useState} from 'react';
import AmazonShowpingLink from '../../AmazonShowpingLink'
import CompareActionButton from '../../options/CompareActionButton'

export default function HelpOptionActions(props){

      return (
      <span >
      {"Using the actions button you can add options for comparison or watch them on amazon."}
      <div className="row pt-3">
          <span className={"col-auto"}>
            <AmazonShowpingLink style={{display:"inline"}} size={"sm"} data={{}}/>
            <div>
              {"Amazon link button"}
            </div>
          </span>
          <span className={"col-auto"}>
            <CompareActionButton   size={"sm"}/>
            <div>
              {"Add to comparison button"}
            </div>
          </span>
      </div>
      </span>);
}
